@if (merchant) {
  <div class="product-view">
    <div class="image">
      <div class="price">{{ utils.formatMoneyByMerchant(product.price, merchant) }}@if (product.deposit) {
        <span class="deposit">+{{ utils.formatMoneyByMerchant(product.deposit, merchant) }}</span>
      }</div>
      <img [src]="image" alt="" />
    </div>
    <div class="product-info">
      <div class="name">
        {{ product.name }}
        @if (product.weight) {
          <span class="weight">{{ product.weight }}g</span>
        }
        @if (!product.weight) {
          <span class="weight no-weight">No weight!</span>
        }
      </div>
      <div class="select" (click)="product.weight && emitReplace()" [ngClass]="{ disabled: !product.weight }">
        @if (isAdd) {
          <span >{{ i18n.instant('replace_product.add') }}</span>
        }
        @if (!isAdd) {
          <span>{{ i18n.instant('replace_product.select') }}</span>
        }
      </div>
    </div>
  </div>
}
